import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import type { AccountAccessModalResult } from 'components/Account/AccountAccess/AccountAccessModal.types'
import Group from 'components/utils/Group'
import ModalContext from 'contexts/ModalContext'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'

function LoyaltyPurchasePointsLoggedOutCta() {
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const onLoginClick = useCallback(() => {
    showModal<AccountAccessModalResult>(<AccountAccessModal initialMode="login" />)
  }, [showModal])

  const description = intl.formatMessage({
    id: 'gSdlDsYiYcL97eyPIZij',
    defaultMessage: 'Log in to your Société account to buy additional points.',
    description: 'Body copy on the Buy Points landing page panel shown when the visitor is logged out',
  })

  const buttonText = intl.formatMessage({
    id: 'APmSWFP0CT9-2c1SPNi3',
    defaultMessage: 'Login to continue',
    description: 'Login button label on the Buy Points landing page panel for logged-out visitors',
  })

  return <Group direction="vertical" gap={16}>
    <BodyText variant="medium">{description}</BodyText>
    <TextButton kind="primary" size="medium" onClick={onLoginClick}>
      {buttonText}
    </TextButton>
  </Group>
}

export default LoyaltyPurchasePointsLoggedOutCta
